import Vue from 'vue'
import Api from '@/api'

Vue.use(Api, {
  baseURL: process.env.VUE_APP_API_URL,
  resources: {
    'order-addresses': { primaryKey: ['order_id', 'customer_address_id'] },
    order: { filterRules: { query: { value: val => val.split(' '), operator: 'like' }, }},
  },
})
